/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var t;!function(t){t.Horizontal="horizontal",t.Vertical="vertical",t.Direct="direct"}(t||(t={}));const r=[t.Horizontal,t.Vertical,t.Direct];export{t as LengthDimensionMeasureType,r as lengthDimensionMeasureType};
